import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button } from "@platform/design-system";

import type React from "react";

interface DeleteRateStructureConfirmDialogProps {
  open: boolean;
  planLabel: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteRateStructureConfirmDialog({
  open,
  planLabel,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteRateStructureConfirmDialogProps): React.JSX.Element {
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isDeleting) onCancel();
      }}
      data-testid="delete-rate-structure-confirm-dialog"
    >
      <DialogTitle>Delete Rate Structure</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will delete the current rate structure and all rates in it for{" "}
          <strong>{planLabel}</strong>. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting} variant="secondary">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="primary" disabled={isDeleting}>
          {isDeleting ? "Deleting…" : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
